<template>
  <div class="flex items-center justify-center w-full h-full gap-5">
    <button
      @click="
        $emit('close-modal')
        handleStopSession
      "
      class="flex items-center justify-center w-16 h-16 text-black bg-[#e9ecf0] rounded-full cursor-pointer"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="size-7 h-7"
      >
        <path
          fill-rule="evenodd"
          d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "SessionStopped",
  props: {
    stopSession: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    handleStopSession() {
      this.stopSession()
    },
  },
}
</script>
